<template>
    <el-drawer
        title="批量打标签"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content">
            <el-alert type="warning" title="注意：批量打标签会重设已选照片（包括已有标签的照片）的标签" :closable="false"></el-alert>
            <el-form
                :model="formData"
                :rules="rules"
                ref="formData"
                label-position="top"
                size="medium"
                class="MT20"
            >
                
                <!-- <el-form-item label="当前演出：">
                    {{activityName}}
                </el-form-item> -->
                <div><span class="color-info">当前演出：</span>{{activityName}}</div>
                <el-form-item v-if="tagsList && tagsList.length > 0" prop="tagsId" label="关联标签：" class="MT20">
                    <el-select v-model="formData.tagsId" filterable clearable default-first-option>
                        <el-option v-for="item in tagsList" :key="item.id" :value="item.id" :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <div v-else class="color-danger"><el-icon class="el-icon-warning"></el-icon> 当前演出无对应标签</div>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading"
                >确认</el-button
            >
        </div>
    </el-drawer>
</template>
<script>
const defaultData = {
    photoIds: "",
    tagsId: "",
}
export default {
    props:{
        activityName:{
            type: String,
            default: ""
        },
        tagsList:{
            type: Array,
            default: () => {
				return [];
			}
        }
    },
    data(){
        return{
            drawerShow: false,
            btnLoading: false,
            formData:{
                ...defaultData
            },
            rules: {}
        }
    },
    methods:{
        close(){
            this.$refs.formData.resetFields();
            this.drawerShow = false;
            this.formData = {
                ...defaultData
            }
        },
        show(ids){
            this.formData.photoIds = ids.toString();
            this.drawerShow = true;
        },
        submitForm(){
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;    
                    this.$request({
                        url: '/photo/setTags',
                        params: {
                            ...this.formData,
                        },
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.$emit('onUpdate');
                                this.close();
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            self.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });   
                } else {
                    return false;
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>

</style>